import Document from "~/models/read/Checkout/Document";
import Order from "~/models/read/Checkout/Order";
import Invoice from "~/models/read/Checkout/Invoice";
import Voucher from "~/models/read/Checkout/Voucher";
import Money from "~/models/Money";
import PlagiarismBundle from "~/models/read/Checkout/PlagiarismBundle";

export default class Checkout {
  private readonly _id: string;
  private readonly _document: Document;
  private readonly _order: Order;
  private readonly _paymentConfig: object;
  private readonly _paymentMethodsConfig: object;
  private readonly _invoice: Invoice;
  private readonly _plagiarismBundleSize: Number | null;
  private readonly _isFree: boolean;
  private readonly _isFreeBecauseOfPlagiarismBundleCoupon: boolean;
  private readonly _aiProofreaderTimeLimit: string;
  private readonly _aiProofreader30DaysPrice: Money | null;
  private readonly _plagiarismCouponOffer: Voucher | null;
  private readonly _errorMessages: object;
  private readonly _paymentError: object;
  private readonly _plagiarismBundles: object;
  private readonly _freePlagiarismCheckWithOrder: boolean;
  private readonly _paraphraserMode: string;
  private readonly _premiumParaphraserSelected: boolean;

  constructor({
                id,
                document,
                order,
                config, // TODO deprecated property - remove after API is updated
                paymentConfig,
                invoice,
                paymentMethodsConfig,
                plagiarismBundleSize,
                isFree,
                isFreeBecauseOfPlagiarismBundleCoupon,
                aiProofreaderTimeLimit,
                aiProofreader30DaysPrice,
                plagiarismCouponOffer,
                errorMessages,
                paymentError,
                plagiarismBundles,
                freePlagiarismCheckWithOrder,
                paraphraserMode,
                premiumParaphraserSelected,
              }) {
    this._id = id;
    this._document = new Document(document);
    this._order = new Order(order);
    this._paymentConfig = paymentConfig || config;
    this._paymentMethodsConfig = paymentMethodsConfig;
    this._invoice = new Invoice(invoice);
    this._plagiarismBundleSize = plagiarismBundleSize;
    this._isFree = isFree;
    this._isFreeBecauseOfPlagiarismBundleCoupon = isFreeBecauseOfPlagiarismBundleCoupon;
    this._aiProofreaderTimeLimit = aiProofreaderTimeLimit;
    this._aiProofreader30DaysPrice = aiProofreader30DaysPrice ? new Money(aiProofreader30DaysPrice) : null;
    this._plagiarismCouponOffer = plagiarismCouponOffer ? new Voucher(plagiarismCouponOffer) : null;
    this._errorMessages = errorMessages;
    this._paymentError = paymentError;
    this._plagiarismBundles = plagiarismBundles ? plagiarismBundles.map(b => new PlagiarismBundle(b)) : null;
    this._freePlagiarismCheckWithOrder = freePlagiarismCheckWithOrder;
    this._paraphraserMode = paraphraserMode;
    this._premiumParaphraserSelected = premiumParaphraserSelected;
  }

  get id(): string {
    return this._id;
  }

  get document(): Document {
    return this._document;
  }

  get order(): Order {
    return this._order;
  }

  get paymentConfig(): object {
    return this._paymentConfig;
  }

  get paymentMethodsConfig(): object {
    return this._paymentMethodsConfig;
  }

  get invoice(): Invoice {
    return this._invoice;
  }

  get currency(): string {
    return this._invoice.total.currency;
  }

  get plagiarismBundleSize(): Number | null {
    return this._plagiarismBundleSize;
  }

  get isFree(): Boolean {
    return this._isFree;
  }

  get isFreeBecauseOfPlagiarismBundleCoupon(): Boolean {
    return this._isFreeBecauseOfPlagiarismBundleCoupon;
  }

  get aiProofreader30DaysPrice(): Money| null {
    return this._aiProofreader30DaysPrice;
  }

  get aiProofreaderTimeLimit(): String {
    return this._aiProofreaderTimeLimit;
  }

  get plagiarismCouponOffer(): Voucher | null {
    return this._plagiarismCouponOffer;
  }

  get errorMessages(): object {
    return this._errorMessages;
  }

  get paymentError(): object {
    return this._paymentError;
  }

  get plagiarismBundles(): object {
    return this._plagiarismBundles;
  }

  get freePlagiarismCheckWithOrder(): boolean {
    return this._freePlagiarismCheckWithOrder;
  }

  get isAIHumanizer(): boolean {
    return this._paraphraserMode === 'humanizer';
  }

  get premiumParaphraserSelected() : boolean {
    return this._premiumParaphraserSelected;
  }
}
